module.exports = __webpack_public_path__ + "media/dog-profile-avatars/single-chihuahua-4f563334.svg";